import React, { useEffect, useState, useCallback } from "react";
import {
  Table,
  Form,
  Select,
  Button,
  Space,
  Row,
  Col,
  Tooltip,
  Input,
  message,
} from "antd";
import "../Pages/CSS/DonnesBases.css";
import { GestionPaieService } from "../Services/GestionPaieService";
import { DeleteFilled } from "@ant-design/icons";
import confirm from "antd/es/modal/confirm";

const { Option } = Select;

const Rubriques = () => {
  const [form] = Form.useForm();
  const [editing, setEditing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10)
  const userProfil = localStorage.getItem("profil");
  const gestionPaieService = new GestionPaieService();

  const fetchAllData = useCallback(async () => {
    try {
      const modelisation = await gestionPaieService.getAllRubriques();
      setTableData(modelisation);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      message.error("Erreur lors de la récupération des données.");
    }
  }, [gestionPaieService]);

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();

      const payload = {
        code: values.code,
        intitule: values.intitule,
        type: values.type,
        valdefaut: values.valdefaut,
      };

      await gestionPaieService.updateRubriques(payload);

      await fetchAllData();
      setEditing(false);
      form.resetFields();
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      message.error("Erreur lors de la mise à jour.");
    }
  };

  const handleAddModelisation = async () => {
    try {
      const values = await form.validateFields();

      const payload = {
        code: values.code,
        intitule: values.intitule,
        type: values.type,
        valdefaut: values.valdefaut,
      };

      await gestionPaieService.addRubriques(payload);

      await fetchAllData();
      setEditing(false);
      form.resetFields();
    } catch (error) {
      console.error("Erreur lors de l’ajout de données :", error);
      message.error("Erreur lors de l’ajout de données.");
    }
  };

  const handleDelete = async (code) => {
    try {
      await gestionPaieService.deleteRubrique(code);

      await fetchAllData();
      form.resetFields();
      setEditing(false);
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
      message.error("Erreur lors de la suppression.");
    }
  };

  const showAddConfirm = () => {
    confirm({
      title: 'Voulez-vous vraiment ajouter cette rubrique?',
      content: 'Cette action ajoutera une nouvelle rubrique.',
      onOk: handleAddModelisation,
      onCancel() {
        console.log('Ajout annulé');
      },
    });
  };

  const showUpdateConfirm = () => {
    confirm({
      title: 'Voulez-vous vraiment modifier cette rubrique?',
      content: 'Cette action modifiera les informations de la rubrique sélectionnée.',
      onOk: handleUpdate,
      onCancel() {
        console.log('Modification annulée');
      },
    });
  };

  const showDeleteConfirm = (code) => {
    confirm({
      title: 'Êtes-vous sûr de vouloir supprimer cette rubrique?',
      content: 'Cette action est irréversible.',
      okText: 'Oui',
      okType: 'danger',
      cancelText: 'Non',
      onOk: () => {
        handleDelete(code);
      },
      onCancel() {
        console.log('Suppression annulée');
      },
    });
  };



  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => a.code.toString().localeCompare(b.code.toString),
    },
    {
      title: "Intitule",
      dataIndex: "intitule",
      key: "intitule",
      sorter: (a, b) => a.intitule.toString().localeCompare(b.intitule.toString()),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      align: "center",
      sorter: (a, b) => a.type.localeCompare(b.type),
    },
    {
      title: "Valeur par Defaut",
      dataIndex: "valdefaut",
      key: "valdefaut",
      sorter: (a, b) => (a.valdefaut || 0) - (b.valdefaut || 0), // Comparaison numérique
    },
    ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5'
      ? [
        {
          title: (
            <div
              style={{
                backgroundColor: "#010f1c",
                color: "white",
                padding: "1px",
              }}
            ></div>
          ),
          align: "center",
          fixed: "right",
          render: (text, record) => (
            <span>
              <Tooltip title="Supprimer">
                <DeleteFilled
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => showDeleteConfirm(record.code)}
                />
              </Tooltip>
            </span>
          ),
        },
      ]
      : []),
  ].filter((column) => column);


  const onRowClick = (record) => {
    form.setFieldsValue({
      code: record.code,
      intitule: record.intitule,
      type: record.type,
      valdefaut: record.valdefaut,
    });
    setEditing(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setEditing(false);
  };

  return (
    <div>
      {userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' && (
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8} lg={6} xl={3}>
              <Form.Item
                name="code"
                label="Code"
              >
                <Input
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                  disabled={!editing}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="intitule"
                label="Intitulé"
                rules={[
                  { required: true, message: "L’intitulé est obligatoire" },
                  { max: 50, message: "L’intitulé ne peut pas dépasser 50 caractères" },
                ]}
              >
                <Input
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true, message: "Sélectionnez un type" }]}
              >
                <Select
                  placeholder="Sélectionnez un type"
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                  disabled={editing}
                >
                  <Option value="Brut">Brut</Option>
                  <Option disabled value="Base">Base</Option>
                  <Option value="Cotisation">Cotisation</Option>
                  <Option value="Gain">Gain</Option>
                  <Option value="Retenue">Retenue</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={5}>
              <Form.Item
                name="valdefaut"
                label="Valeur par Défaut"
                initialValue={0}
                rules={[
                  { required: true, message: "La valeur par défaut est obligatoire" },
                  { pattern: /^[0-9]+$/, message: "Entrez un nombre valide" },
                ]}
              >
                <Input
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={6} style={{ display: "flex", justifyContent: "right" }}>
              {editing ? (
                <Space>
                  <Button
                    style={{ marginTop: 10 }}
                    type="primary"
                    onClick={showUpdateConfirm}
                    htmlType="submit"
                  >
                    Modifier
                  </Button>
                  <Button style={{ marginTop: 10 }} onClick={handleCancel}>
                    Annuler
                  </Button>
                </Space>
              ) : (
                <Space>
                  <Button
                    style={{ marginTop: 10 }}
                    type="primary"
                    htmlType="submit"
                    onClick={showAddConfirm}
                  >
                    Enregistrer
                  </Button>
                </Space>
              )}
            </Col>
          </Row>
        </Form>
      )}
      <Table
        dataSource={tableData}
        columns={columns}
        scroll={{ x: true }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        bordered
        showSorterTooltip={false}
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
      />
    </div>
  );
};

export default Rubriques;
